import moduleRegistry from '../module-registry/module-registry';
import { Breakpoints } from '../breakpoints/breakpoints';
const config = {
    selectors: {
        root: '.category-overview',
        tab: '.category-overview__tab',
        tabItem: '.category-overview__tab-item',
        tabsContent: '.category-overview__tab-content',
        tabsContentWrapper: '.category-overview__tab-content-wrapper',
        grid: '.category-overview__tab-content-grid',
        tabButton: '.category-overview__tab-button',
        ctaButton: '.cta-button',
        slickTrack: '.slick-track',
        slickActiveButton: '.cta-button, .slick-active',
        tabsContentActive: '.category-overview__tab-content.slick-slide.slick-current.slick-active',
        tabsContentNotActive: '.category-overview__tab-content.slick-slide:not(slick-active)',
        loadMoreButton: '.category-overview__tab-load-more-btn',
        gridItem: '.category-overview__grid-item',
        gridItemLabel: '.category-overview__grid-item-label',
        gridItemContentButton: '.category-overview__grid-item-content-button',
        gridItemContent: '.category-overview__grid-item-content'
    },
    classNames: {
        tabContent: 'category-overview__tab-content',
        tabsActive: 'category-overview__tab-content--active',
        tabsVisible: 'category-overview__tab-content--visible',
        ctaButtonActive: 'cta-button--button-blue--active',
        tabItemActive: 'category-overview__tab-item--active',
        tabContentGridModifierPrefix: 'category-overview__tab-content-grid--',
        gridItemHover: 'category-overview__grid-item--hover',
        gridItemHoverOut: 'category-overview__grid-item--hover-out',
        gridItemLabelNoAnimation: 'category-overview__grid-item-label--no-animation',
        gridItemLabelContentButtonNoAnimation: 'category-overview__grid-item-content-button--no-animation',
        gridItemLabelContentNoAnimation: 'category-overview__grid-item-content--no-animation'
    },
    dataAttributes: {
        index: 'index',
    },
    breakPoints: {
        xs: 0,
        sm: 767,
        md: 991,
        lg: 1440,
        xl: 1920,
        xxl: 2000,
    },
    tabSliderSettings: {
        // slidesToShow: 4,
        // slidesToScroll: 1,
        // dots: false,
        // arrows: false,
        // // centerMode: true,
        // focusOnSelect: true,
        // variableWidth: true,
        // infinite: false,
        // swipeToSlide: true,
    },
};

class CategoryOverview {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
        this._loadmore = false;
    }

    init() {
        this._elements = this._getDomElements();
        this._addClassesForContent();
        this._addEventListeners();
        this._loadMoreClickHandler();

        const _this = this;
        this._elements.$tab.on('init', (event, slick, direction) => {
            _this._slickSliderManipulation();
        });
        this._slickSliderFunctions();

        // this._unslickIfNonTouchOnMD();

        // $(window).on('resize', () => {
        //     this._unslickIfNonTouchOnMD();
        // });

        this._elements.$tabItem.on('click', function(e)  {
            const $el = $(this);
            const index = $el.data(config.dataAttributes.index);

            _this._elements.$tabsContent.removeClass(config.classNames.tabsActive);

            _this._elements.$tabItem.removeClass(config.classNames.tabItemActive);
            $(this).addClass(config.classNames.tabItemActive);

            setTimeout(() => {
                _this._elements.$tabsContent.removeClass(config.classNames.tabsVisible);
                $(_this._elements.$tabsContent[index]).addClass(config.classNames.tabsVisible);
                    
                    setTimeout(() => {
                        $(_this._elements.$tabsContent[index]).addClass(config.classNames.tabsActive);
                    }, 5);
            }, 650);
            
        });

        
        $(_this._elements.$tabsContent[0]).addClass(config.classNames.tabsVisible);
        $(_this._elements.$tabsContent[0]).addClass(config.classNames.tabsActive);
        $(_this._elements.$tabItem[0]).addClass(config.classNames.tabItemActive);
    }

    _getDomElements() {
        return {
            $tab: this._$rootElement.find(config.selectors.tab),
            $tabItem: this._$rootElement.find(config.selectors.tabItem),
            $tabsContent: this._$rootElement.find(config.selectors.tabsContent),
            $tabsContentWrapper: this._$rootElement.find(config.selectors.tabsContentWrapper),
            $tabButton: this._$rootElement.find(config.selectors.tabButton),
            $grid: this._$rootElement.find(config.selectors.grid),
            $ctaButton: this._$rootElement.find(config.selectors.ctaButton),
            $slickActiveButton: this._$rootElement.find(config.selectors.slickActiveButton),
            $tabsContentActive: this._$rootElement.find(config.selectors.tabsContentActive),
            $tabsContentNotActive: this._$rootElement.find(config.selectors.tabsContentNotActive),
            $loadMoreButton: this._$rootElement.find(config.selectors.loadMoreButton),
            $gridItem: this._$rootElement.find(config.selectors.gridItem),
            $gridItemLabel: this._$rootElement.find(config.selectors.gridItemLabel),
            $gridItemContentButton: this._$rootElement.find(config.selectors.gridItemContentButton),
            $gridItemContent: this._$rootElement.find(config.selectors.gridItemContent)
        };
    }

    _addEventListeners() {
        this._elements.$ctaButton.on('focus', (e) => {
            $(e.target).trigger('click');
        });

        const height = $('.category-overview__grid-item')[0].scrollHeight
        console.log($('.category-overview__grid-item')[0].sc)
   
       
        this._$rootElement.find('div.category-overview__grid-item').on('click', (e) => {

            if(Breakpoints.isBreakpointOrSmaller('sm')) {
                const parent =  e.target.closest(config.selectors.gridItem);
                const childlabel = parent.querySelector(config.selectors.gridItemLabel);
                const childContent = parent.querySelector(config.selectors.gridItemContent);
                const img = parent.querySelector('.picture img');
                const allNoLinkElements = $('div.category-overview__grid-item')
                // const height = parent.scrollHeight  - 40
                // $(childContent).css('max-height',height+ 'px')

                allNoLinkElements.find('.picture img').css('opacity','1')
                allNoLinkElements.find(config.selectors.gridItemContent).css('opacity','0')
                allNoLinkElements.find(config.selectors.gridItemContent).css('display','none')
                allNoLinkElements.find(config.selectors.gridItemContent).css('visibility','hidden')
                allNoLinkElements.find(config.selectors.gridItemContent).css('visibility','hidden')
                allNoLinkElements.find(config.selectors.gridItemLabel).css('visibility','visible')
                allNoLinkElements.find(config.selectors.gridItemLabel).css('opacity','1')

                $(childContent).removeClass(config.classNames.gridItemLabelContentNoAnimation);
    
                $(childlabel).addClass(config.classNames.gridItemLabelNoAnimation);
                //if onlytext
                let childOnlytext;
                            
                if($(e.target).hasClass('category-overview__grid-item--text-only')) {
                    childOnlytext = e.target.querySelector(config.selectors.gridItemLabel);
                }

                $(childlabel).css("opacity", "0");
                $(childlabel).css("visibility", "hidden");
                $(img).css("opacity", "0.3");
                $(childlabel).css("opacity", "0");
                $(childContent).css("opacity", "1");
                $(childOnlytext).css("opacity", "1");
                $(childOnlytext).css("visibility", "visible");
                $(childContent).css("visibility", "visible");
                $(childContent).css("display", "block");
            }
           

           
        })

        this._elements.$gridItem.on('mouseenter ', (e) => {
           
                $(e.target).closest(config.selectors.gridItem).addClass(config.classNames.gridItemHover);
                $(e.target).closest(config.selectors.gridItem).removeClass(config.classNames.gridItemHoverOut);
               
                const parent =  e.target.closest(config.selectors.gridItem);
                const childlabel = parent.querySelector(config.selectors.gridItemLabel);
                const childbutton = parent.querySelector(config.selectors.gridItemContentButton);
                const childContent = parent.querySelector(config.selectors.gridItemContent);
                // const height = parent.scrollHeight - 40
                // $(childContent).css('max-height',height+ 'px')
                $(childContent).removeClass(config.classNames.gridItemLabelContentNoAnimation);
                $(childbutton).removeClass(config.classNames.gridItemLabelContentButtonNoAnimation);
    
                $(childlabel).addClass(config.classNames.gridItemLabelNoAnimation);
    
                //if onlytext
                let childOnlytext;
              
                if($(e.target).hasClass('category-overview__grid-item--text-only')) {
                    childOnlytext = e.target.querySelector(config.selectors.gridItemLabel);
                }
        
                setTimeout(() => {
                   $(childlabel).css("opacity", "0");
                   $(childbutton).css("opacity", "1");
                   $(childContent).css("opacity", "1");
                   $(childOnlytext).css("opacity", "1");
                   $(childContent).css("visibility", "visible");
                }, 1);
          
            
          
          
        })
        this._elements.$gridItem.on('mouseleave ', (e) => {
            
                $(e.target).closest(config.selectors.gridItem).removeClass(config.classNames.gridItemHover);
                $(e.target).closest(config.selectors.gridItem).addClass(config.classNames.gridItemHoverOut);
    
                const parent =  e.target.closest(config.selectors.gridItem);
                const childlabel = parent.querySelector(config.selectors.gridItemLabel);
                const childbutton = parent.querySelector(config.selectors.gridItemContentButton);
                const childContent = parent.querySelector(config.selectors.gridItemContent);
               
                // $(childContent).css('max-height', 'auto')
                $(childbutton).addClass(config.classNames.gridItemLabelContentButtonNoAnimation);
                $(childContent).addClass(config.classNames.gridItemLabelContentNoAnimation);
                $(childlabel).removeClass(config.classNames.gridItemLabelNoAnimation);
    
                setTimeout(() => {
                     $(childlabel).css("opacity", "1");
                     $(childbutton).css("opacity", "0");
                     $(childContent).css("opacity", "0");
                     $(childContent).css("visibility", "hidden");
                  }, 1);
            
           
             
        })
    }

    _isTouchDevice() {
        return (('ontouchstart' in window)
           || (navigator.maxTouchPoints > 0)
           || (navigator.msMaxTouchPoints > 0));
    }

    // _unslickIfNonTouchOnMD() {
    //     if (!this._isTouchDevice() && Breakpoints.isBreakpoint('sm')) {
    //         console.log('window-size between 768 and 1440px');
    //         // this._elements.$tab.slick('unslick');
    //         this._elements.$tab.addClass('category-overview__tab--desktop-small');

    //         // hide buttons with index more than 2 + show load-more button
    //         this._elements.$tab.children().each((index, item) => {
    //             if (index > 2) {
    //                 $(item).hide();
    //                 this._elements.$loadMoreButton.html(this._elements.$loadMoreButton.attr('more'));
    //                 this._elements.$loadMoreButton.show();
    //             }
    //         });
    //     } else if (!this._elements.$tab.hasClass('slick-initialized')) {
    //         // this._elements.$tab.removeClass('category-overview__tab--desktop-small');
    //         // this._elements.$tab.slick(config.tabSliderSettings);
    //         // this._elements.$loadMoreButton.hide();
    //     }
    //     console.log('isTouchDevice: ', this._isTouchDevice());
    // }

    _loadMoreClickHandler() {
        this._elements.$loadMoreButton.on('click', () => {
            if (!this._loadmore) {
                this._loadmore = true;
                this._elements.$tab.children().each((index, item) => {
                    $(item).show();
                    this._elements.$loadMoreButton.html(this._elements.$loadMoreButton.attr('less'));
                });
            } else {
                this._loadmore = false;
                this._elements.$tab.children().each((index, item) => {
                    if (index > 2) {
                        $(item).hide();
                        this._elements.$loadMoreButton.html(this._elements.$loadMoreButton.attr('more'));
                        this._elements.$loadMoreButton.show();
                    }
                });
            }
        });
    }

    _setTabActive(dataId) {
        this._elements.$tabsContent.removeClass(config.classNames.tabsActive);
        this._getTabContentByID(dataId).addClass(config.classNames.tabsActive);
    }

    _getTabContentByID(dataId) {
        return this._$rootElement.find(`${config.selectors.tabsContent}[data-id=${dataId}]`);
    }

    _addClassesForContent() {
        const gridContent = this._elements.$grid;

        for (let i = 0; i < gridContent.length; i++) {
            const contentLength = $(gridContent[i])[0].children.length;
            $(gridContent[i])[0].classList.add(`${config.classNames.tabContentGridModifierPrefix + contentLength}`);
        }
    }

    _slickSliderFunctions() {
        // this._elements.$tabsContentWrapper.slick({
        //     slidesToShow: 1,
        //     slidesToScroll: 1,
        //     arrows: false,
        //     fade: true,
        //     asNavFor: '.category-overview__tab',
        //     adaptiveHeight: true,
        // });
        // this._elements.$tab.slick(config.tabSliderSettings);
        // this._elements.$tab.slick('setPosition');
    }

    _slickSliderManipulation() {
        const _this = this;
        this._elements.$tabsContentActive.attr('tabindex', 0);

        const activeChildren = $(config.selectors.tabsContentActive).children();
        for (let i = 0; i < activeChildren.length; i++) {
            const activeChildrenOfGrid = $(activeChildren[i]).children();
            for (let m = 0; m < activeChildrenOfGrid.length; m++) {
                $(activeChildrenOfGrid[m]).attr('tabindex', 0);
            }
        }
    }
}

moduleRegistry.registerModule('CategoryOverview', CategoryOverview);
moduleRegistry.autoApplyModule('CategoryOverview', config.selectors.root);
